import DataGrid from 'app/components/DataGrid';
import MarketingModal from './MarketingModal';
import useMarketing from 'app/hooks/useMarketing';

const Marketing = props => {
  const {
    resource,
    formIsOpen,
    currentRecord,
    onFormClose,
    onAdd,
    onEdit,
    onDataGridLoad,
    onFormSubmit,
    onDestroy,
    showFilters,
    getRowData
  } = useMarketing();

  const header = 'Marketing';
  const addButtonLabel = 'Add Marketing';
  const columnOrder = ['name', 'popup_header', 'popup_description', 'popup_caption', 'enabled'];
  const visibleColumns = columnOrder;
  const omitColumns = [];
  const actions = [];

  const columnDefOverrides = [
    {
      field: 'name',
      headerName: 'Name',
      quickEdit: true
    },
    {
      field: 'popup_header',
      headerName: 'Popup Header',
      quickEdit: true
    },
    {
      field: 'popup_caption',
      headerName: 'Popup Caption',
      quickEdit: true
    },
    {
      field: 'popup_description',
      headerName: 'Popup Description',
      quickEdit: true
    },
    {
      field: 'enabled',
      headerName: 'Enabled',
      cellRenderer: params => {
        let data = params.data;
        if (data) {
          return data.enabled ? 'YES' : 'NO';
        }
        return '';
      }
    }
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        showQuickEdit={true}
        columnOrder={columnOrder}
        visibleColumns={visibleColumns}
        columnDefOverrides={columnDefOverrides}
        omitColumns={omitColumns}
        showFilters={showFilters}
        loadingMessage="Loading marketing..."
        showSelect={true}
        actions={actions}
        onDataGridLoad={onDataGridLoad}
      />
      <MarketingModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        marketing={currentRecord}
        onFormSubmit={onFormSubmit}
        onDestroy={onDestroy}
      />
    </div>
  );
}

export default Marketing;
